import {useMemo} from 'react';

import ErrorLocatePlugin from './errorLocate';
import FlexBuilderPlugin from './flexBuilder';
import BackendFlexBuilderPlugin from './flexBuilder/backend';

const errorLocatePluginAllowRepoList = [
    'ZzIjzst2PP', // KF-知识库-FE研发
    'jbwM46hj3x', // KF-知识库-后端main
    'k8imtmH06L', // 线上个人知识库
    'ja7LaxzZWP', // RD个人知识库
];

export const useMorphoPlugin = (repositoryGuid: string) => {
    return useMemo(() => {
        const extensions = [FlexBuilderPlugin, BackendFlexBuilderPlugin];

        if (errorLocatePluginAllowRepoList.includes(repositoryGuid)) {
            extensions.push(ErrorLocatePlugin);
        }

        return {
            extensions,
        };
    }, [repositoryGuid]);
};
